import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import { noop } from 'ui-components/default-props/noop';

import Global from '../../../../../store/global-selectors';
import { SimpleDropdown } from '../../../../simple-dropdown';

const messages = defineMessages({
  defaultLabel: {
    description: 'deliveryEmailTemplateDropdownContainer.defaultLabel',
    defaultMessage: 'Delivery Email Notification',
    id: '3HTJ3F',
  },
  defaultTitle: {
    description: 'deliveryEmailTemplateDropdownContainer.defaultTitle',
    defaultMessage: 'Select Template',
    id: 'iMemAX',
  },
});

export const DeliveryEmailTemplateDropdown = ({
  dropdownMenuShouldHaveWidthOfButton = false,
  onItemSelected = noop,
  required = false,
  selectedDeliveryEmailTemplateId = '',
  hasError = false,
}) => {
  const label = <FormattedMessage {...messages.defaultLabel} />;
  const defaultTitle = <FormattedMessage {...messages.defaultTitle} />;

  const deliveryEmailTemplates = useSelector(Global.selectSellerDeliveryTemplates);
  const items = deliveryEmailTemplates.map(({ name, emailTemplateId }) => ({
    name,
    key: emailTemplateId,
  }));

  return (
    <SimpleDropdown
      defaultTitle={defaultTitle}
      dropdownMenuShouldHaveWidthOfButton={dropdownMenuShouldHaveWidthOfButton}
      hasError={hasError}
      items={items}
      label={label}
      onItemSelected={onItemSelected}
      required={required}
      selectedItemKey={selectedDeliveryEmailTemplateId}
    />
  );
};

DeliveryEmailTemplateDropdown.propTypes = {
  dropdownMenuShouldHaveWidthOfButton: PropTypes.bool,
  onItemSelected: PropTypes.func,
  required: PropTypes.bool,
  selectedDeliveryEmailTemplateId: PropTypes.string,
  hasError: PropTypes.bool,
};
